import React, { useEffect, useState, useRef } from 'react';
import Participant from './Participant';
// import ListParticipants from './ListParticipants';
import '../styles/videoChatStyles';
import { Dish } from '../styles/videoChatStyles';
import '../styles/videoCssStyles.css';

import { useDispatch } from 'react-redux';
import {
  updateNameToList,
  removeNameFromList,
  clearList,
} from '../redux/participantListSlice';

const Room = (props) => {
  const dispatch = useDispatch();
  const [participants, setParticipants] = useState([]);
  const [resizeControl, setResizeControl] = useState([]);
  const contRef = useRef();
  // const elRefRen = props.elRefRen;
  // const showList = props.showList;
  // const hideParticipantsListModal = props.hideParticipantsListModal;
  const room = props.room;
  const controls = props.controls;

  const resize_ob = new ResizeObserver(function (entries) {
    // since we are observing only a single element, so we access the first element in entries array
    let rect = entries[0].contentRect;

    // current width & height
    let width = rect.width;
    let height = rect.height;

    setResizeControl([width, height]);
  });

  useEffect(() => {
    const element = contRef?.current;
    resize_ob.observe(element);
    return () => {
      resize_ob.unobserve(element);
    };
  }, []);

  useEffect(() => {
    dispatch(
      updateNameToList({
        identity: room.localParticipant.identity,
        listType: 'roomParticipants',
      })
    );

    const participantConnected = (participant) => {
      dispatch(
        updateNameToList({
          identity: participant.identity,
          listType: 'roomParticipants',
        })
      );
      setParticipants((prevParticipants) => {
        return [...prevParticipants, participant];
      });
    };

    const participantDisconnected = (participant) => {
      dispatch(
        removeNameFromList({
          identity: participant.identity,
          listType: 'roomParticipants',
        })
      );
      setParticipants((prevParticipants) =>
        prevParticipants.filter((p) => p !== participant)
      );
    };

    room.on('participantConnected', participantConnected);
    room.on('participantDisconnected', participantDisconnected);
    room.participants.forEach(participantConnected);
    return () => {
      room.off('participantConnected', participantConnected);
      room.off('participantDisconnected', participantDisconnected);
      dispatch(clearList({}));

      setParticipants([]);
    };
  }, [room]);

  useEffect(() => {
    Dish();
  }, [participants, resizeControl]);

  const remoteParticipants = participants.map((participant) => (
    <Participant
      key={participant.sid}
      participant={participant}
      speakerMute={controls.speakerMute}
      isPartLocal={false}
    />
  ));

  return (
    <div
      style={{ width: '100%', height: '100%', position: 'relative' }}
      ref={contRef}
    >
      {/* <ListParticipants
        showList={showList}
        participants={participants}
        localParticipant={room.localParticipant.identity}
        hideParticipantsListModal={hideParticipantsListModal}
        elRefRen={elRefRen}
      /> */}
      <div
        id='Dish'
        style={{
          backgroundColor: '#2B2C33', // 11091E --old
          width: '100%',
          height: '100%',
        }}
        data-tut='reactour_participant'
      >
        {room ? (
          <Participant
            key={room.localParticipant.sid}
            participant={room.localParticipant}
            speakerMute={true}
            isPartLocal={true}
            videoMute={controls.videoMute}
            videoFlip={{ transform: `scale(-1,1)` }}
          />
        ) : null}
        {remoteParticipants}
      </div>
    </div>
  );
};

export default Room;
